import './iphone17carousel.css';
import iphone17Image from '../../../assets/apple/iPhone17/iPhone17Slides/iPhone17.png';
import iphone17eImage from '../../../assets/apple/iPhone17/iPhone17Slides/iPhone17e.png';
import iphone17ProImage from '../../../assets/apple/iPhone17/iPhone17Slides/iPhone17Pro.png';

import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { useNavigate } from 'react-router-dom';

const IPhone17Carousel = () => {
  const navigate = useNavigate();
  const [swiperInstance, setSwiperInstance] = useState(null);

  const pauseAutoplay = () => {
    swiperInstance?.autoplay?.stop();
  };

  const resumeAutoplay = () => {
    swiperInstance?.autoplay?.start();
  };

  const handleViewDetails = (productId) => {
    navigate(
      `/applestore/iphone-products-list/iphone-detail-page/iphone/${productId}`
    );
  };

  return (
    <Swiper
      modules={[Pagination, Navigation, Autoplay]}
      navigation
      pagination={{ type: 'progressbar', clickable: true }}
      slidesPerView={1}
      spaceBetween={30}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      style={{ padding: '0 3% 3% 3%;', borderRadius: '40px' }}
      onSwiper={(swiper) => setSwiperInstance(swiper)}
    >
      {/* iPhone 17 Slide */}
      <SwiperSlide>
        <section className="iphone17-carousel">
          <div className="iphone17-content">
            <h1 className="iphone17-title">iPhone 17</h1>
            <h2 className="iphone17-subtitle">Starts at Rs. 82,900</h2>
            <p className="iphone17-emi">or No Cost EMI at Rs. 3,455 p.m.</p>

            <div className="iphone17-image-wrapper">
              <img
                src={iphone17Image}
                alt="iPhone 17"
                className="iphone17-image"
              />
            </div>

            <div className="iphone17-offers">
              <p>
                Cashback up to <strong>Rs. 3000</strong> on Axis/ICICI Credit Cards.
              </p>
              <p className="plus-sign">+</p>
              <p>
                Exchange Bonus up to <strong>Rs. 6000</strong>
              </p>
            </div>

            <button
              className="iphone17-view-details-btn"
              onClick={() => handleViewDetails(1)}
              onMouseEnter={pauseAutoplay}
              onMouseLeave={resumeAutoplay}
            >
              View Details
            </button>

            <p className="iphone17-terms">
              *Terms and Conditions Apply. <br />
              The EMI amount may differ from person to person. <br />
              EMI offers are subject to changes without prior notice.
            </p>
          </div>
        </section>
      </SwiperSlide>

      {/* iPhone 17e Slide */}
      <SwiperSlide>
        <section className="iphone17e-carousel">
          <div className="iphone17-content">
            <h1 className="iphone17-title">iPhone 17e</h1>
            <h2 className="iphone17-subtitle">Starts at Rs. 64,900</h2>
            <p className="iphone17-emi">or No Cost EMI at Rs. 2,705 p.m.</p>

            <div className="iphone17-image-wrapper">
              <img
                src={iphone17eImage}
                alt="iPhone 17e"
                className="iphone17-image"
              />
            </div>

            <div className="iphone17-offers">
              <p>
                Cashback up to <strong>Rs. 2000</strong> on Axis/ICICI Credit Cards.
              </p>
              <p className="plus-sign">+</p>
              <p>
                Exchange Bonus up to <strong>Rs. 6000</strong>
              </p>
            </div>

            <button
              className="iphone17-view-details-btn"
              onClick={() => handleViewDetails(12)}
              onMouseEnter={pauseAutoplay}
              onMouseLeave={resumeAutoplay}
            >
              View Details
            </button>

            <p className="iphone17-terms">
              *Terms and Conditions Apply. <br />
              The EMI amount may differ from person to person. <br />
              EMI offers are subject to changes without prior notice.
            </p>
          </div>
        </section>
      </SwiperSlide>

      {/* iPhone 17 Pro Slide */}
      <SwiperSlide>
        <section className="iphone17Pro-carousel">
          <div className="iphone17-content">
            <h1 className="iphone17-title">iPhone 17 Pro</h1>
            <h2 className="iphone17-subtitle">Starts at Rs. 1,34,900</h2>
            <p className="iphone17-emi">or No Cost EMI at Rs. 5,621 p.m.</p>

            <div className="iphone17-image-wrapper">
              <img
                src={iphone17ProImage}
                alt="iPhone 17 Pro"
                className="iphone17-image"
              />
            </div>

            <div className="iphone17-offers">
              <p>
                Cashback up to <strong>Rs. 4000</strong> on Axis/ICICI Credit Cards.
              </p>
              <p className="plus-sign">+</p>
              <p>
                Exchange Bonus up to <strong>Rs. 6000</strong>
              </p>
            </div>

            <button
              className="iphone17-view-details-btn"
              onClick={() => handleViewDetails(2)}
              onMouseEnter={pauseAutoplay}
              onMouseLeave={resumeAutoplay}
            >
              View Details
            </button>

            <p className="iphone17-terms">
              *Terms and Conditions Apply. <br />
              The EMI amount may differ from person to person. <br />
              EMI offers are subject to changes without prior notice.
            </p>
          </div>
        </section>
      </SwiperSlide>
    </Swiper>
  );
};

export default IPhone17Carousel;
